import { Loading, Modal } from '@carbon/react';
import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Renew } from '@carbon/icons-react';

import { useRefreshInvitationTokenMutation } from 'api/entityEndpoints';
import sharedMessages from 'Components/utils/sharedMessages';
import CommonButton from 'Components/Common/CommonButton/CommonButton';
import useGetUserPermission from 'hooks/useGetUserPermission';

type Props = {
    id: string;
}

const RefreshInvitationTokenButton = ({
    id,
}: Props) => {
    const intl = useIntl();
    const { isAdmin, isOwner } = useGetUserPermission();

    const [refreshToken, { isLoading: isLoadingDelete }] = useRefreshInvitationTokenMutation();
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

    const onRefreshRequest = () => {
        setConfirmationModalOpen(true);
    };

    const onModalClose = () => {
        setConfirmationModalOpen(false);
    };

    const onSubmit = async () => {
        try {
            await refreshToken(id);
        } catch (e: unknown) {
            // TO_DO
            console.log(e);
        }
        setConfirmationModalOpen(false);
    };

    return (
        <>
            <CommonButton
                label={intl.formatMessage(messages.newAddToken)}
                kind="ghost"
                disabled={!isAdmin && !isOwner}
                icon={<Renew size={21} />}
                onClick={onRefreshRequest}
            />
            <Modal
                preventCloseOnClickOutside
                open={confirmationModalOpen}
                onRequestClose={onModalClose}
                danger
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onRequestSubmit={onSubmit}
                modalHeading={intl.formatMessage(messages.areYouSure)}
                modalLabel={intl.formatMessage(messages.generateNewToken)}
                primaryButtonText={intl.formatMessage(sharedMessages.generate)}
                closeButtonLabel={intl.formatMessage(sharedMessages.cancel)}
                secondaryButtonText={intl.formatMessage(sharedMessages.back)}
            />
            {isLoadingDelete && <Loading />}
        </>
    );
};

const messages = defineMessages({
    generateNewToken: {
        id: 'src.Screens.Dashboard.AllEntities.EntityTable.EntityInteractions.'
        + 'RefreshInvitationTokenButton.RefreshInvitationTokenButton.generateNewToken',
        defaultMessage: 'Generowanie nowego kodu dołączenia',
    },
    areYouSure: {
        id: 'src.Screens.Dashboard.AllEntities.EntityTable.EntityInteractions.RefreshInvitationTokenButton.RefreshInvitationTokenButton.areYouSure',
        defaultMessage: 'Jesteś pewien, że chcesz wygenerować kod na nowo? Poprzedni będzie nieaktualny, a ta operacja jest nieodwracalna.',
    },
    newAddToken: {
        id: 'src.Screens.Dashboard.AllEntities.EntityTable.EntityInteractions.RefreshInvitationTokenButton.RefreshInvitationTokenButton.newAddToken',
        defaultMessage: 'Wygeneruj nowy kod dołączenia',
    },
});

export default RefreshInvitationTokenButton;
